import { Crop, StoreCrops, OLCropResponse, OLCrop, ProductType } from '../types';

/**
 * Return an object of crops using crop code ids as keys
 */
export function extractCropListFromSprout(cropList: OLCropResponse): StoreCrops {
  return cropList.data.crops.nodes.reduce<StoreCrops>(
    (result, currCrop) => ({
      ...result,
      [currCrop.cropLegacyIds.cropCode]: toCrop(currCrop),
    }),
    {}
  );
}

/**
 * Map Sprout Crops to Crop data model we have in DMB
*/
function toCrop(olCrop: OLCrop): Crop {
  return {
    'legacy-id': parseInt(olCrop.cropLegacyIds.id, 10),
    'updated-at': olCrop.updatedAt,
    name: olCrop.name,
    'product-type': olCrop.breedingMethod.toLowerCase() as ProductType,
    code: olCrop.cropLegacyIds.cropCode,
    uuid: olCrop.cropLegacyIds.uuid,
    'dfp-uuid': olCrop.id,
    'nominal-weight': olCrop.nominalWeight,
    'nominal-moisture': olCrop.nominalMoisture,
  }
}
